import { Box, styled } from '@mui/material';

type PurchaseRemarkContainerProps = {
  padding?: string;
  height?: string;
  isFooter?: boolean;
  width?: string;
};

export const PurchaseRemarkContainerStyled = styled(Box)<PurchaseRemarkContainerProps>(({ theme, ...props }) => ({
  background: 'rgba(0, 0, 0, 0.12)',
  borderRadius: '4px',
  color: 'white',
  padding: props.padding || '14px',
  height: props.height || '100%',
  width: props.width || '100%',
  display: 'flex',

  '.container-box': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'inherit',
    justifyContent: 'start',
  },

  '.remark-icon': {
    width: '22px',
    height: '22px',
    position: 'relative',
  },

  '.title-text': {
    whiteSpace: 'pre-line',
    wordWrap: 'break-word',

    [theme.breakpoints.between('md', 'lg')]: {
      width: !props.isFooter ? '330px' : '198px',
      fontSize: props.isFooter ? '18px' : '24px',
      whiteSpace: 'pre-line',
      wordWrap: 'break-word',
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      whiteSpace: 'pre-line',
      wordWrap: 'break-word',
    },
  },
}));
